import { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import TableClasses from "Components/TableLoad";

import { FiPlus } from "react-icons/fi";
import { IoPencil } from "react-icons/io5";
import { MdDelete } from "react-icons/md";
import { useSearchParams } from "react-router-dom";
import ReactPaginate from "react-paginate";

import ImagePreview from "Components/ImagePreview";
import Moment from "react-moment";
import {
    showErrorAlert,
    showWarningAlert,
    confirmAction,
    Toast,
} from "Util/Alerts";

import { campaignsType } from "./Types";

import {
    Get_campaigns,
    Delete_campaigns,
    searchCampaignByProduct,
    End_campaigns,
} from "Services/Requests";

import Styles from "Styles/Styles.module.css";

function CampaignsComp() {
    const Navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [Count, setCount] = useState(0);
    const [forcepage, setfocrcepage] = useState(0);
    const [showPaginate, setShowPaginate] = useState(false);

    let TableHead = [
        "SKU",
        "Campaign Code",
        "Product",
        "Prizes",
        "Category Name",
        "Campaign Tag",
        "campaign_stock",
        "Available Stock",
        "Created At",
        "Actions",
    ];
    const [campaigns, setcampaigns] = useState<campaignsType[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    // State to handle modal visibility and the selected image
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedTerm, setDebouncedTerm] = useState("");

    const getcampaigns = async (page: any) => {
        setLoading(true);
        try {
            const response = await Get_campaigns(page);
            if (response?.data?.status === 1) {
                setcampaigns(response?.data?.campaigns);
                setCount(response?.data?.pageCount);
                if (response?.data?.pageCount > 1) {
                    setShowPaginate(true);
                }
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };

    const Deletecampaigns = async (id: any) => {
        setLoading(true);
        try {
            const response = await Delete_campaigns(id);
            if (response?.data?.status === 1) {
                Toast("campaigns Deleted Successfully", "success");
                setfocrcepage(0);
                if (searchTerm.length > 0) {
                    setSearchTerm("");
                } else {
                    getcampaigns(1);
                }
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };
    const End = async (id: any) => {
        setLoading(true);
        try {
            const response = await End_campaigns({ campaign_id: id });
            if (response?.data?.status === 1) {
                Toast("campaigns Ended", "success");
                setfocrcepage(0);
                if (searchTerm.length > 0) {
                    setSearchTerm("");
                } else {
                    getcampaigns(1);
                }
            } else {
                setLoading(false);
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            setLoading(false);
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        }
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setDebouncedTerm(searchTerm);
        }, 500); // Debounce delay of 500ms

        return () => clearTimeout(timer); // Cleanup function to clear timeout
    }, [searchTerm]);

    useEffect(() => {
        if (debouncedTerm) {
            SearchCampaign();
        } else {
            let page = searchParams.get("page") ?? 1;

            setSearchParams({
                page: page.toString(),
            });

            setfocrcepage(Number(page) - 1);
            getcampaigns(page);
        }
    }, [debouncedTerm]);
    // Function to close the modal
    const handleCancel = () => {
        setIsModalVisible(false);
        setSelectedImage(null);
    };
    const SearchCampaign = async () => {
        setLoading(true);
        try {
            const response = await searchCampaignByProduct({
                search_term: debouncedTerm,
            });
            if (response?.data?.status === 1) {
                setcampaigns(response?.data?.data);
                setShowPaginate(false);
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    const deleteHandler = (item: campaignsType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to Delete campaign?",
            () => Deletecampaigns(item.campaign_id),
            "Delete"
        );
    };
    const EndHandler = (item: campaignsType) => {
        confirmAction(
            "Warning",
            "Are you sure you want to End campaign?",
            () => End(item.campaign_id),
            "Delete"
        );
    };
    const handlePageChange = (selectedObject: any) => {
        setSearchParams({
            page: selectedObject.selected + 1,
        });
        setfocrcepage(selectedObject.selected);
        getcampaigns(selectedObject.selected + 1);
        window.scrollTo({ top: 10, behavior: "smooth" });
    };
    return (
        <div className={Styles["Container"]}>
            <ImagePreview
                handleCancel={handleCancel}
                isModalVisible={isModalVisible}
                selectedImage={selectedImage}
                title="campaigns"
            />
            <header>
                <h3>Campaign Products</h3>
                <button
                    className={Styles["Add_cat_btn"]}
                    onClick={() => Navigate("/auth/campaigns/add")}>
                    <FiPlus />
                    Add campaign Product
                </button>
            </header>
            <div className={Styles["search"]}>
                <input
                    type="text"
                    placeholder="Search campaign By Product"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>
            {loading ? (
                <TableClasses TableHead={TableHead} />
            ) : (
                <div className={Styles["tableWrapper"]}>
                    <table>
                        <thead>
                            {TableHead.map((item) => (
                                <th>{item}</th>
                            ))}
                        </thead>
                        <tbody>
                            {campaigns.length > 0 ? (
                                campaigns?.map((item) => (
                                    <tr key={item?.campaign_id}>
                                        <td>{item?.sku}</td>
                                        <td>{item.campaign_code}</td>
                                        <td style={{ width: "8rem" }}>
                                            {item.product_name}
                                        </td>
                                        <td>{item?.giveaway_product_name}</td>
                                        <td>{item.category_name}</td>
                                        <td>{item.campaign_category_name}</td>
                                        <td>{item.campaign_stock}</td>
                                        <td>{item?.stock_available}</td>
                                        <td style={{ width: "6rem" }}>
                                            <Moment format="DD-MM-YYYY" utc>
                                                {item.created_at}
                                            </Moment>
                                        </td>

                                        <td>
                                            <div
                                                className={
                                                    Styles["Action_Tabs"]
                                                }>
                                                <button
                                                    onClick={() =>
                                                        Navigate(
                                                            "/auth/campaigns/edit",
                                                            { state: item }
                                                        )
                                                    }>
                                                    <IoPencil size={24} />
                                                </button>

                                                <button
                                                    onClick={() =>
                                                        deleteHandler(item)
                                                    }>
                                                    <MdDelete size={22} />
                                                </button>
                                                {
                                                    <button
                                                        className={
                                                            Styles[
                                                                "endcampaign"
                                                            ]
                                                        }
                                                        disabled={
                                                            item?.stock_available ==
                                                            0
                                                        }
                                                        onClick={() =>
                                                            EndHandler(item)
                                                        }>
                                                        End
                                                    </button>
                                                }
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan={TableHead.length}>
                                        No campaigns Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {showPaginate && (
                        <ReactPaginate
                            pageCount={Count}
                            // pageRange={2}
                            forcePage={forcepage}
                            marginPagesDisplayed={2}
                            onPageChange={handlePageChange}
                            breakClassName={"page-item"}
                            breakLinkClassName={"page-link"}
                            containerClassName={"pagination"}
                            pageClassName={"page-item"}
                            pageLinkClassName={"page-link"}
                            previousClassName={"page-item"}
                            previousLinkClassName={"page-link"}
                            nextClassName={"page-item"}
                            nextLinkClassName={"page-link"}
                            activeClassName={"active"}
                        />
                    )}
                </div>
            )}
        </div>
    );
}

export default CampaignsComp;
